module.exports = __webpack_public_path__ + "img/2-lugar.53beca25.svg";